import React from 'react';

export function ChevronIcon({ className }: { className?: string }): React.JSX.Element {
  return (
    <svg
      viewBox="0 0 12 8"
      fill="none"
      stroke="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <path d="M1.33341 6.5L6.00008 1.83333L10.6667 6.5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}